// File: src/components/GroupCompaniesBundleCard.js

import React, { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";

import Badge from "../../ui/Badge/Badge";
import IsraelCard from "./IsraelCard"; // Import the PlanCard component
import { dataLanguage } from "../../../i18n/translateRequest";
import translate from "../../../i18n/translate";

const GroupCompaniesBundleCard = ({
  columnStyle,
  item,
  onTypeClick,
  index,
  collapseRef,
  isDarkTheme,
  moveCard,
  id,
  logo,
  smallLogo,
  isImageVisible = false,
  isSelected = false,
}) => {
  const ref = useRef(null);

  const [{ handlerId }, drop] = useDrop({
    accept: "cards",
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(dragItem, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = dragItem.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) {
        return;
      }
      moveCard(dragIndex, hoverIndex);
      dragItem.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: "cards",
    item: () => {
      return { id, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(ref));
  const opacity = isDragging ? 0 : 1;

  return (
    <div
      className={`${columnStyle} mt-3`}
      data-handler-id={handlerId}
      style={{ opacity }}
    >
      <div className="card charge-card" ref={ref}>
        <div
          style={{ cursor: "pointer" }}
          data-placement="top"
          onClick={() => onTypeClick(item)}
        >
          {isImageVisible ? (
            <div className="position-relative">
              <img alt={item.title} src={item.url} width={"100%"}></img>
              {(item.renew === "True" || item.renew === "true") && (
                <Badge text={translate("Renewable")}></Badge>
              )}
            </div>
          ) : (
            <IsraelCard
              data={item} // just pass the whole object
              logo={logo}
              smallLogo={smallLogo}
              isDarkTheme={isDarkTheme}
              isSelected={isSelected}
            />
          )}
        </div>
      </div>
      <div className={`${isDarkTheme ? "dark-card" : "card"}`}>
        <div className="text-center" id="headingOne">
          <h5 className="mb-0 mx-">
            <div
              className="link-main details"
              style={{ fontWeight: "bolder" }}
              data-toggle="collapse"
              data-target={"#" + index}
              aria-expanded="true"
              aria-controls={index}
            >
              <small>{translate("Details")}</small>
            </div>
          </h5>
        </div>

        <div
          id={index}
          className="collapse"
          aria-labelledby="headingOne"
          data-parent="#accordion"
          ref={(el) => (collapseRef.current[index] = el)}
        >
          <div className="card-body">
            <small>
              {dataLanguage(item, "ar_title", "en_title", "he_title")}
            </small>
            <br />
            <small>{dataLanguage(item, "ar_des", "en_des", "he_des")}</small>
            <br />
            {(() => {
              const bundleId = item.PCI || item.pci || item.bundleid || item.bundle_id || 
                               item.PID || item.pid || item.cardid || item.card_id || 
                               item.productid || item.Operator_Card_ID || 
                               item.EPRS_card_ID || item.Peletalk_Card_ID;
              return bundleId ? (
                <small style={{ display: "block", textAlign: "center", marginTop: "8px", color: "#666" }}>
                  [{bundleId}]
                </small>
              ) : null;
            })()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupCompaniesBundleCard;
